<template>
	<div>
		<svg
			:width="size"
			:height="size"
			viewBox="0 0 24 24"
			:fill="color"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7.25 4.75C7.25 5.16421 7.58579 5.5 8 5.5C8.41421 5.5 8.75 5.16421 8.75 4.75V4.25H11.25V4.75C11.25 5.16421 11.5858 5.5 12 5.5C12.4142 5.5 12.75 5.16421 12.75 4.75V4.25H15.25V4.75C15.25 5.16421 15.5858 5.5 16 5.5C16.4142 5.5 16.75 5.16421 16.75 4.75V4.25H18C18.2761 4.25 18.5 4.47386 18.5 4.75V20.75C18.5 21.0261 18.2761 21.25 18 21.25H6C5.72386 21.25 5.5 21.0261 5.5 20.75V4.75C5.5 4.47386 5.72386 4.25 6 4.25H7.25V4.75ZM16.75 2.75H18C19.1046 2.75 20 3.64543 20 4.75V20.75C20 21.8546 19.1046 22.75 18 22.75H6C4.89543 22.75 4 21.8546 4 20.75V4.75C4 3.64543 4.89543 2.75 6 2.75H7.25L7.25 1.75C7.25 1.33579 7.58579 1 8 1C8.41421 1 8.75 1.33579 8.75 1.75V2.75H11.25V1.75C11.25 1.33579 11.5858 1 12 1C12.4142 1 12.75 1.33579 12.75 1.75V2.75H15.25V1.75C15.25 1.33579 15.5858 1 16 1C16.4142 1 16.75 1.33579 16.75 1.75V2.75ZM7.5 12.75C7.5 12.3358 7.83579 12 8.25 12H12H15.75C16.1642 12 16.5 12.3358 16.5 12.75C16.5 13.1642 16.1642 13.5 15.75 13.5H12H8.25C7.83579 13.5 7.5 13.1642 7.5 12.75ZM7.5 15.75C7.5 15.3358 7.83579 15 8.25 15H12H14.2352C14.6494 15 14.9852 15.3358 14.9852 15.75C14.9852 16.1642 14.6494 16.5 14.2352 16.5H12H8.25C7.83579 16.5 7.5 16.1642 7.5 15.75ZM7.5 18.75C7.5 18.3358 7.83579 18 8.25 18H12C12.4142 18 12.75 18.3358 12.75 18.75C12.75 19.1642 12.4142 19.5 12 19.5H8.25C7.83579 19.5 7.5 19.1642 7.5 18.75Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'noteIcon',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
